<template>
    <widget-wrapper
        :loader="api"
        :title="$t('widgets.quick_insights.title')"
        class="quick_insights" id="quick-insights">

        <div class="pie__container">
            <percentage-pie class="pie" :fraction="currentPeriod.conversion">
                <span class="pie__percentage">{{$n(currentPeriod.conversion, 'percentage_whole')}}</span>
                <span class="pie__label">{{$t('widgets.quick_insights.label_conversion_current')}}</span>
            </percentage-pie>
            <percentage-pie class="pie" :fraction="comparePeriod.conversion">
                <span class="pie__percentage">{{$n(comparePeriod.conversion, 'percentage_whole')}}</span>
                <span class="pie__label">{{$t('widgets.quick_insights.label_conversion_compare')}}</span>
            </percentage-pie>
            <percentage-pie class="pie" :fraction="currentPeriod.conversion - comparePeriod.conversion">
                <span class="pie__percentage">{{$n(currentPeriod.conversion - comparePeriod.conversion, 'percentage_whole')}}</span>
                <span class="pie__label">{{$t('widgets.quick_insights.label_conversion_delta')}}</span>
            </percentage-pie>
        </div>

        <p class="text-center text-small">
            ({{$t('widgets.quick_insights.label_range', {start:comparePeriod.start, end: comparePeriod.end})}})
        </p>
    </widget-wrapper>
</template>

<script>
    import {Component} from 'vue-property-decorator';
    import DashboardWidget from '../DashboardWidget';
    import WidgetWrapper from '../WidgetWrapper';
    import WidgetData from '../WidgetDataDecorator';
    import PercentagePie from './PercentagePie';
    import moment from 'moment';

    @Component({
        components: {
            WidgetWrapper,
            PercentagePie,
        }
    })
    export default class QuickInsightsWidget extends DashboardWidget {
        api = {
            endpoint: 'dashboard/api/sales/quick_insights'
        };
        @WidgetData(() => ({
            'num_total_appointments': 8,
            'num_total_orders': 9,
            'num_total_appointments_second_period': 7,
            'num_total_orders_second_period': 10,
            'second_period': {'start': '2017-05-08', 'end': '2017-12-31'},
            'conversion_rate': 88.88888888888889,
            'conversion_rate_second_period': 70
        }))
        response;

        get currentPeriod() {
            return {
                start: moment(this.query.daterange.start).calendar(),
                end: moment(this.query.daterange.end).calendar(),
                total_appointments: parseInt(this.response.num_total_appointments),
                total_orders: parseInt(this.response.num_total_orders),
                conversion: this.response.conversion_rate/100,
            };
        }

        get comparePeriod() {
            return {
                start: moment(this.response.second_period.start).calendar(),
                end: moment(this.response.second_period.end).calendar(),
                total_appointments: parseInt(this.response.num_total_appointments_second_period),
                total_orders: parseInt(this.response.num_total_orders_second_period),
                conversion: this.response.conversion_rate_second_period/100,
            };
        }

        onQueryData({data}) {
            this.response = data;
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/widgets/quick-insights/QuickInsightsWidget.vue